import routes from 'defs/routes';
import { RootStateType as ProgramDaysRootState } from 'store/programDays';
import { ViewActionType } from './view.actionCreators';
import {
	CLOSE_OFF_CANVAS,
	OPEN_OFF_CANVAS,
	REQUEST_RESTORE_LAST_SCROLL_POSITION,
	REQUEST_SAVE_SCROLL_POSITION,
	REQUEST_VIEW_FAILURE,
	REQUEST_VIEW_LOADING,
	REQUEST_VIEW_SUCCESS,
	SAVE_VIEW_ID,
} from './view.actionTypes';

export type ViewStateType = {
	readonly currentViewID: null | string;
	readonly isOffCanvasOpen: boolean;
	readonly currentViewTitle: null | string;
	readonly lastScrollPosition: null | number;
	readonly lastRestoredScrollPosition: null | number;
	readonly lastScrollPositionById: { [key: string /*ScrollElementIdEnumType*/]: null | number };
	readonly lastRestoredScrollPositionById: { [key: string /*ScrollElementIdEnumType*/]: null | number };
} & object;

export type RootStateType = {
	view: ViewStateType;
} & ProgramDaysRootState;

const scrollTo = (x: number, y: number): void => window.scrollTo(x, y);

export const initialState: any = {
	currentViewID: null,
	isOffCanvasOpen: false,
	currentViewTitle: null,
	lastScrollPosition: null,
	lastRestoredScrollPosition: null,
	lastScrollPositionById: {},
	lastRestoredScrollPositionById: {},
	[routes.profile.indexRoute.id]: {
		isLoading: true,
		hasError: false,
	},
	[routes.today.indexRoute.id]: {
		isLoading: false,
		hasError: false,
	},
};

export default (state: ViewStateType = initialState, action: ViewActionType): ViewStateType => {
	switch (action.type) {
		case REQUEST_SAVE_SCROLL_POSITION:
			return action.scrollElementId
				? {
						...state,
						lastScrollPositionById: {
							...state.lastScrollPositionById,
							[action.scrollElementId]: action.position,
						},
				  }
				: {
						...state,
						lastScrollPosition: action.position,
				  };
		case REQUEST_RESTORE_LAST_SCROLL_POSITION:
			if (action.scrollElementId) {
				const scrollElementId = action.scrollElementId;
				scrollTo(0, state.lastScrollPositionById[scrollElementId] || 0);
				const newState = { ...state };
				newState.lastScrollPositionById[scrollElementId] = null;
				newState.lastRestoredScrollPositionById[scrollElementId] =
					state.lastScrollPositionById[scrollElementId];
				return newState;
			}
			scrollTo(0, state.lastScrollPosition || 0);
			return {
				...state,
				lastScrollPosition: null,
				lastRestoredScrollPosition: state.lastScrollPosition,
			};
		case SAVE_VIEW_ID as any:
			return {
				...state,
				currentViewID: ((action as any) as { viewID: string }).viewID,
			};
		case OPEN_OFF_CANVAS:
			return {
				...state,
				isOffCanvasOpen: true,
			};
		case CLOSE_OFF_CANVAS:
			return {
				...state,
				isOffCanvasOpen: false,
			};

		case REQUEST_VIEW_LOADING:
			return {
				...state,
				[action.view]: {
					isLoading: action.status,
					hasError: false,
				},
			};
		case REQUEST_VIEW_SUCCESS:
			return {
				...state,
				[action.view]: {
					isLoading: false,
					hasError: false,
				},
			};
		case REQUEST_VIEW_FAILURE:
			return {
				...state,
				[action.view]: {
					isLoading: false,
					hasError: true,
				},
			};

		default:
			return state;
	}
};
